export const he = {
  externalSso: {
    title: 'המשך עם ההתחברות של הארגון שלך',
    description:
      'ייפתח חלון להתחברות דרך ספק הזהויות שלך. חזור לכאן לאחר שהחלון ייסגר.',
    returnToOriginalWindow: 'חזור לחלון שבו התחלת להתחבר כדי להמשיך.',
    completionFailed:
      'לא הצלחנו להשלים את ההתחברות. התחל מחדש מדף ההתחברות או מרשימת האפליקציות של הארגון.',
    popupBlocked:
      'הדפדפן חסם את חלון ההתחברות. אפשר חלונות קופצים לאתר זה ונסה שוב.',
  },
  common: {
    signOut: 'התנתק',
    cancel: 'ביטול',
    save: 'שמור',
    loading: 'טוען...',
    error: 'אירעה שגיאה',
    success: 'הצלחה',
    continue: 'המשך',
    email: 'אימייל',
    getStarted: 'בואו נתחיל',
    retry: 'נסה שוב',
  },
  profile: {
    title: 'פרופיל',
    account: 'חשבון',
    email: 'אימייל',
    language: 'שפה',
    theme: {
      title: 'ערכת נושא',
      light: 'בהיר',
      dark: 'כהה',
    },
    languages: {
      en: 'אנגלית',
      he: 'עברית',
    },
  },
  home: {
    welcomeBack: 'ברוך שובך!',
    signedInAs: 'אתה מחובר בתור',
  },
  auth: {
    cannotLogInAsUser: 'לא ניתן להתחבר כמשתמש זה',
    enterSparkAccountUsername: 'הזן את שם המשתמש של החשבון שלך',
    loginToYourAccount: 'התחבר לחשבון שלך',
    signInTo: 'התחבר אל',
    username: 'שם משתמש',
    next: 'הבא',
    enterEmail: 'הזן את האימייל שלך',
    magicLinkInfo: 'נשלח לך קישור קסם להתחברות',
    emailPlaceholder: 'your@email.com',
    continue: 'המשך',
    verifyingEmail: 'מאמת את האימייל שלך',
    pleaseWait: 'אנא המתן בזמן שאנו מאמתים את כתובת האימייל שלך',
    success: 'הצלחה!',
    nowSignedIn: 'אתה מחובר כעת בתור',
    continueToApp: 'המשך לאפליקציה',
    email: 'אימייל',
    password: 'סיסמה',
    enterPassword: 'הזן את הסיסמה שלך',
    enterPasswordFor: 'הזן את הסיסמה שלך עבור',
    forgotPassword: 'שכחת סיסמה?',
    emailRequired: 'אימייל נדרש',
    passwordRequired: 'סיסמה נדרשת',
    invalidCredentials: 'פרטי התחברות שגויים',
    checkCredentials: 'אנא בדוק את האימייל והסיסמה שלך ונסה שוב.',
    signIn: 'התחבר',
    signingIn: 'מתחבר...',
    approveTitle: 'אשר במכשיר',
    checkDevice: 'בדוק את המכשיר שלך',
    approvePrompt: 'אנא אשר את בקשת ההתחברות',
    requestRejected: 'בקשת ההתחברות נדחתה',
    tryAgain: 'נסה שוב',
    samlError: 'שגיאה בעיבוד תגובת האימות',
    genericError: 'אירעה שגיאה. אנא נסה שוב.',
    networkError: 'שגיאת חיבור רשת. אנא בדוק את החיבור שלך ונסה שוב.',
    errors: {
      emptyEmail: 'אנא הזן את כתובת האימייל שלך',
      invalidEmail: 'אנא הזן כתובת אימייל תקינה',
      generic: 'משהו השתבש. אנא נסה שוב.',
    },
  },
  notifications: {
    testButton: 'בדוק התראה',
    title: 'התראת בדיקה',
    body: 'זוהי התראת בדיקה מ-NewCore!',
    requestPermission: 'אפשר התראות',
    tokenAvailable: 'טוקן התראות זמין',
  },
  mfa: {
    loading: 'טוען פרטי בקשה...',
    genericError: 'נכשל בטעינת פרטי הבקשה',
    approved: 'אושר',
    approvedMessage: 'אישרת בהצלחה את בקשת ההתחברות.',
    declined: 'נדחה',
    declinedMessage: 'דחית את בקשת ההתחברות.',
    noRequestDetails: 'אין פרטי בקשה זמינים',
    requestingAccess: 'מבקש גישה',
    user: 'משתמש',
    location: 'מיקום',
    device: 'מכשיר',
    time: 'זמן',
    confirmIdentity: 'אנא אשר שזה אתה מנסה להתחבר',
    decline: 'דחה',
    approve: 'אשר',
    challengeFailed: 'אתגר האימות נכשל',
    challengeNotFound: 'אתגר האימות לא נמצא',
    autoActionError: 'נכשל בעיבוד אוטומטי של הבקשה',
    resendNotification: 'שלח התראה מחדש',
    resendError: 'נכשל בשליחת ההתראה מחדש. נסה שוב.',
    unsupportedFactor: 'שיטת אימות לא נתמכת',
    unsupportedFactorMessage:
      "שיטת האימות '{{factorType}}' עדיין לא נתמכת. אנא צור קשר עם המנהל שלך.",
    invalidRequest: 'בקשה לא תקינה',
    missingParameters:
      'חסרים פרמטרי אימות נדרשים. אנא התחל מחדש את תהליך ההתחברות.',
    maxRetriesExceeded: 'מספר הניסיונות המקסימלי הושג. אנא נסה שוב מאוחר יותר.',
    waitingForApproval: 'ממתין לאישור',
    checkYourDevice: 'בדוק את המכשיר הנייד שלך עבור התראת האישור',
    resendAvailableSoon: 'תוכל לשלוח את ההתראה מחדש בעוד מספר שניות',
    loginApproved: 'בקשת ההתחברות אושרה בהצלחה',
    loginDeclined: 'בקשת ההתחברות נדחתה',
    canCloseWindow: 'כעת ניתן לסגור חלון זה',
    loginDetails: 'פרטי התחברות',
    ipAddress: 'כתובת IP',
    expired: 'הבקשה פגה',
    requestExpired: 'בקשת האימות פגה. אנא נסה להתחבר שוב.',
    redirecting: 'מעביר...',
    noDeviceRegistered: 'אין מכשיר רשום',
    noDeviceMessage: 'אין מכשיר נייד רשום לקבלת התראות. אנא רשום מכשיר תחילה.',
    registerDeviceHint:
      'התקן את האפליקציה הניידת והפעל התראות כדי להשתמש בשיטת אימות זו.',
    checkYourSparkApp: 'בדוק את אפליקציית NewCore שלך',
    notificationSentMessage:
      'שלחנו התראה למכשיר שלך.\nהקש על כן בהתראה כדי להמשיך.',
    visualMatchMessage:
      'אתגר חזותי נשלח למכשיר שלך.\nבחר את התמונה הזו במכשיר הנייד שלך כדי להמשיך.',
    visualMatchImageAlt: 'אתגר התאמה חזותי במכשיר שלך',
    imageLoadError: 'טעינת התמונה נכשלה',
    didntReceiveIt: 'לא קיבלת?',
    requestNewCodeIn: 'בקש קוד חדש בעוד',
    requestNewNotificationIn: 'בקש התראה חדשה בעוד',
    resendLimitReached: 'הגעת למגבלת השליחות מחדש.',
    verifyUsingTotp: 'אמת באמצעות אפליקציית אימות',
    networkError: 'לא הצלחנו להתחבר לשרת. בדוק את החיבור ונסה שוב.',
  },
};
